import React, { useRef, useEffect } from 'react';
import { Button } from './ui/button';

const RichTextEditor = ({ value, onChange, placeholder, rows = 3 }) => {
  const editorRef = useRef(null);
  const isUpdating = useRef(false);

  useEffect(() => {
    if (editorRef.current && !isUpdating.current) {
      editorRef.current.innerHTML = value || '';
    }
  }, [value]);

  const handleInput = () => {
    if (editorRef.current) {
      isUpdating.current = true;
      onChange(editorRef.current.innerHTML);
      setTimeout(() => {
        isUpdating.current = false;
      }, 0);
    }
  };

  const applyFormat = (command) => {
    document.execCommand(command, false, null);
    editorRef.current?.focus();
  };

  return (
    <div className="border rounded-md overflow-hidden">
      {/* Toolbar */}
      <div className="flex gap-1 p-2 bg-gray-50 border-b">
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={() => applyFormat('bold')}
          className="px-3 py-1 font-bold"
          title="Bold"
        >
          B
        </Button>
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={() => applyFormat('italic')}
          className="px-3 py-1 italic"
          title="Italic"
        >
          I
        </Button>
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={() => applyFormat('underline')}
          className="px-3 py-1 underline"
          title="Underline"
        >
          U
        </Button>
      </div>
      
      {/* Editor */}
      <div
        ref={editorRef}
        contentEditable
        onInput={handleInput}
        className="p-3 min-h-[80px] focus:outline-none focus:ring-2 focus:ring-purple-500"
        style={{ 
          minHeight: `${rows * 24}px`,
          maxHeight: '300px',
          overflowY: 'auto'
        }}
        suppressContentEditableWarning
        data-placeholder={placeholder}
      />
      
      <style jsx>{`
        [contentEditable]:empty:before {
          content: attr(data-placeholder);
          color: #9ca3af;
          pointer-events: none;
        }
      `}</style>
    </div>
  );
};

export default RichTextEditor;
